import { Component, input, output, signal, inject } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import {
    lucideChevronDown,
    lucideChevronRight,
    lucideArrowRight,
    lucideTrophy,
    lucideShoppingBag,
    lucideShoppingCart,
    lucideHelpCircle,
    lucideBriefcase,
    lucideUser,
    lucideLogOut,
    lucideLayoutDashboard,
} from '@ng-icons/lucide'
import {
    HeaderMenuType,
    DealGroup,
    FunActivity,
} from '../../header-client.types'

@Component({
    selector: 'app-header-client-mobile-drawer',
    imports: [RouterModule, NgIcon],
    providers: [
        provideIcons({
            lucideChevronDown,
            lucideChevronRight,
            lucideArrowRight,
            lucideTrophy,
            lucideShoppingBag,
            lucideShoppingCart,
            lucideHelpCircle,
            lucideBriefcase,
            lucideUser,
            lucideLogOut,
            lucideLayoutDashboard,
        }),
    ],
    templateUrl: './header-client-mobile-drawer.component.html',
    styleUrl: './header-client-mobile-drawer.component.css',
})
export class HeaderClientMobileDrawerComponent {
    private readonly router = inject(Router)

    isOpen = input<boolean>(false)
    dealGroups = input<DealGroup[]>([])
    funActivities = input<FunActivity[]>([])
    isLoggedIn = input<boolean>(false)
    displayName = input<string>('')
    displayEmail = input<string>('')
    displayRole = input<string>('')
    displayInitials = input<string>('')
    showClientDashboard = input<boolean>(false)

    closeDrawer = output<void>()
    logout = output<void>()

    mobileAccordion = signal<HeaderMenuType | null>('deals')

    toggleAccordion(section: HeaderMenuType) {
        if (this.mobileAccordion() === section) {
            this.mobileAccordion.set(null)
        } else {
            this.mobileAccordion.set(section)
        }
    }

    navigateToCategory(slug: string) {
        this.closeDrawer.emit()
        this.router.navigate(['/category', slug])
    }

    navigateToClaimedItems() {
        this.closeDrawer.emit()
        this.router.navigate(['/client/claimed-items'])
    }

    onClose() {
        this.closeDrawer.emit()
    }

    onLogout() {
        this.logout.emit()
    }
}
